module.exports = __webpack_public_path__ + "assets/aaa1056ae5aa36447518ce40ca7b6686.mp3";